import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Main page components
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import GovernmentSolutionsPage from './pages/GovernmentSolutionsPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';

// Individual service pages
import CyberSecurityPage from './pages/services/CyberSecurityPage';
import CounterIntelligencePage from './pages/services/CounterIntelligencePage';
import SurveillancePage from './pages/services/SurveillancePage';
import DroneServicesPage from './pages/services/DroneServicesPage';
import DigitalForensicsPage from './pages/services/DigitalForensicsPage';
import SoftwareDevelopmentPage from './pages/services/SoftwareDevelopmentPage';
import FireFightingSystemPage from './pages/services/FireFightingSystemPage';
import WarehouseManagementPage from './pages/services/WarehouseManagementPage';
import ResearchDevelopmentPage from './pages/services/ResearchDevelopmentPage';
import SafetyEquipmentPage from './pages/services/SafetyEquipmentPage';

// Shared components
import Navigation from './components/Navigation';
import Footer from './components/Footer';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <Navigation />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/government-solutions" element={<GovernmentSolutionsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />


          {/* Individual Service Pages */}
          <Route path="/services/cyber-security" element={<CyberSecurityPage />} />
          <Route path="/services/counter-intelligence" element={<CounterIntelligencePage />} />
          <Route path="/services/surveillance" element={<SurveillancePage />} />
          <Route path="/services/drone-operations" element={<DroneServicesPage />} />
          <Route path="/services/digital-forensics" element={<DigitalForensicsPage />} />
          <Route path="/services/software-development" element={<SoftwareDevelopmentPage />} />
          <Route path="/services/fire-fighting-system" element={<FireFightingSystemPage />} />
          <Route path="/services/warehouse-management" element={<WarehouseManagementPage />} />
          <Route path="/services/research-development" element={<ResearchDevelopmentPage />} />
          <Route path="/services/safety-equipment" element={<SafetyEquipmentPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;